export default "__VITE_ASSET__Cbfrf9YF__"